import { Subject } from "rxjs";

const MessageSuggestionReceiverSubject = new Subject();

const MessageSuggestionService = {
  listen: () => MessageSuggestionReceiverSubject.asObservable(),
  recieveSuggestion: (suggestion) =>
    MessageSuggestionReceiverSubject.next(suggestion),
};

export default MessageSuggestionService;
